import { render, staticRenderFns } from "./ClientsCustomList.vue?vue&type=template&id=31eeaae6"
import script from "./ClientsCustomList.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsCustomList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClientsCustomList.vue?vue&type=style&index=0&id=31eeaae6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports